import React from "react";
import SvgIcon from "@mui/material/SvgIcon";
export const ArrowRight = props => {
    return (React.createElement(SvgIcon, Object.assign({}, props),
        React.createElement("path", { d: "M14.7071068,5.29289322 L21.4142136,12 L14.7071068,18.7071068 L13.2928932,17.2928932 L17.585,12.9998932 L2,13 L2,11 L17.585,10.9998932 L13.2928932,6.70710678 L14.7071068,5.29289322 Z", id: "Combined-Shape" })));
};
export default ArrowRight;
